// Flavor badge: pick a locally-bundled SVG based on the product's flavour NAME.
//
// The catalog returns `product.description.flavour = { id, name, imageUrl }`.
// We ignore the backend imageUrl and map the flavour `name` to an SVG in this repo.
//
// To add/replace a flavour: drop its SVG in src/assets/images/flavors/, import it
// below, and add an entry to FLAVOR_ICONS keyed by the flavour name in UPPERCASE.
// Names are matched case-insensitively, trimmed, and spaces are treated as "-".

import multiCoffeeIcon from "../../../../assets/images/flavors/multi-coffee.svg";
import multiTeaIcon from "../../../../assets/images/flavors/multi-tea.svg";
import europeanIcon from "../../../../assets/images/flavors/european.svg";
import coldIcon from "../../../../assets/images/flavors/cold.svg";
import warmIcon from "../../../../assets/images/flavors/warm.svg";

const FLAVOR_ICONS = {
  "MULTI-COFFEE": multiCoffeeIcon,
  "MULTI-TEA": multiTeaIcon,
  "EUROPEAN": europeanIcon,
  "COLD": coldIcon,
  "WARM": warmIcon,
};

// Uppercase, trim, and collapse whitespace to "-" so "Multi Coffee",
// "multi-coffee" and "MULTI COFFEE" all match the same key.
const normalize = (name) => String(name || "").trim().toUpperCase().replace(/\s+/g, "-");

// Resolve the flavor icon for a product, or null if its flavour has no mapping.
export const getFlavorIcon = (item) => {
  const name = item?.description?.flavour?.name;
  if (!name) return null;
  return FLAVOR_ICONS[normalize(name)] ?? null;
};

// Flavor name for the icon's alt text, or null.
export const getFlavorName = (item) => item?.description?.flavour?.name ?? null;
